// Init
import React from 'react';
import { ToastContainer, Flip } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

// Files
import Index from './routes/index';
import './css/index.css';

// Component
function App() {
  return (
    <div className="App">
      <ToastContainer
        hideProgressBar
        transition={Flip}
        autoClose={3000}
        position="bottom-right"
      />
      <Index />
    </div>
  );
}

// Export
export default App;
